import { useMemo } from 'react'

import { Outlet, useParams } from 'react-router'

import { adminRoutes } from '@bettermode/domain/routes/web/admin'
import { SpinnerIcon } from '@bettermode/icons/solid/Spinner'
import { useCMS, findPostType } from '@tribeplatform/react-components/CMS'
import { T } from '@tribeplatform/react-components/i18n'
import { useRouter } from '@tribeplatform/react-sdk'
import { useNetwork } from '@tribeplatform/react-sdk/hooks'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'

export function CMSRouteWrapper() {
  const { slug } = useParams<{ slug: string }>()

  if (!slug) {
    throw new Error('Slug is required')
  }

  const {
    data: { id: networkId },
  } = useNetwork()
  const { postTypes } = useCMS()
  const postType = useMemo(
    () => findPostType({ networkId, slug, postTypes }),
    [networkId, slug, postTypes],
  )

  const context = useMemo(() => ({ postType }), [postType])

  return <Outlet context={context} />
}

const colon = ':'

export function CMSBreadCrumb() {
  const { slug } = useParams<{ slug: string }>()
  const { postTypes } = useCMS()
  const {
    data: { id: networkId },
  } = useNetwork()
  const postType = useMemo(
    () => findPostType({ networkId, slug, postTypes }),
    [networkId, slug, postTypes],
  )
  const { Link } = useRouter()
  return (
    <Link
      href={adminRoutes.site.cms.detail(slug)}
      className="flex items-center gap-1"
    >
      <SvgIcon name="database-01" />
      <span className="text-sm">
        <T id="Generics.CMS" defaultMessage="CMS" />
        {colon}
      </span>
      {postType?.name ? (
        postType.name
      ) : (
        <SpinnerIcon className="animate-spin" />
      )}
    </Link>
  )
}
